// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"92f4a7e3","470":"4e330fa6","825":"fbb5055e"}[chunkId] + ".chunk.js";
};